const ModeratorInsightsReduser = (state = [], action) => {
    switch (action.type) {
        case 'MODERATOR_INSIGHTS_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default ModeratorInsightsReduser